import React from 'react'
import PropTypes from 'prop-types'
import { confirmable } from 'react-confirm'
import Button from './Button'

const ExtendedConfirmDialog = ({ show, proceed, dismiss, cancel, confirmation, options }) => {
    if (!show) return null

    // V2: nuevo diseño ─────────
    if (options.isV2) {
        return (
            <React.Fragment>
                <div
                    className="confirm-v2__overlay"
                    onClick={() => cancel()}
                />
                <div className="confirm-v2__dialog" role="dialog" aria-modal="true">
                    <div className="confirm-v2__header">
                        <h3 className="confirm-v2__title">{options.title || confirmation}</h3>
                        <button
                            className="confirm-v2__close"
                            onClick={() => cancel()}
                            aria-label="Cerrar"
                            datacy="confirm_dialog__cancel"
                        >
                            <i className="fas fa-times" />
                        </button>
                    </div>

                    <hr className="confirm-v2__divider" />

                    <div className="confirm-v2__body">
                        <p className="confirm-v2__message">
                            {confirmation}
                        </p>
                        {options.advise && (
                            <p className="confirm-v2__advise">
                                {options.advise}
                            </p>
                        )}
                    </div>

                    <div className="confirm-v2__footer">
                        <button
                            className="confirm-v2__btn confirm-v2__btn--cancel"
                            onClick={() => cancel()}
                            datacy="confirm_dialog__cancel"
                        >
                            {options.textCancel || 'Cancelar'}
                        </button>
                        <Button
                            inverted
                            onClick={() => proceed()}
                            datacy="confirm_dialog__ok"
                        >
                            {options.textOk || 'Ok'}
                        </Button>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    // V1: diseño original ─────────
    return (
        <div className="modal-v2 v2">
            <div className="full-overlay" style={{ display: show ? 'block' : 'none' }} />
            <div id="confirm-container" className="confirm" style={{ display: show ? 'block' : 'none' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 container p-0">
                            <header className="container-fluid">
                                <button
                                    className="confirm-dialog-close"
                                    onClick={() => cancel('arguments will be passed to the callback')}
                                    datacy="confirm_dialog__cancel"
                                >
                                    <i className="fal fa-times" />
                                </button>
                                <div className="row">
                                    <div className="col-12">
                                        <div>
                                            <h2>{confirmation}</h2>
                                            {options.advise && (
                                                <div className="confirm-advise">
                                                    {options.advise}
                                                </div>
                                            )}
                                            <div className="confirm-btn-group">
                                                <div>
                                                    <Button
                                                        onClick={() => cancel('arguments will be passed to the callback')}
                                                        datacy="confirm_dialog__cancel"
                                                    >
                                                        {options.textCancel ? options.textCancel : 'Cancel'}
                                                    </Button>
                                                </div>
                                                <div>
                                                    <Button
                                                        className="bt-inverted"
                                                        onClick={() => proceed('same as cancel')}
                                                        datacy="confirm_dialog__ok"
                                                    >
                                                        {options.textOk ? options.textOk : 'Ok'}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </header>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

ExtendedConfirmDialog.propTypes = {
    show: PropTypes.bool, // from confirmable. indicates if theyarn start dialog is shown or not.
    proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
    cancel: PropTypes.func, // from confirmable. call to close the dialog with promise rejected.
    dismiss: PropTypes.func, // from confirmable. call to only close the dialog.
    confirmation: PropTypes.string, // arguments of your confirm function
    options: PropTypes.object // arguments of your confirm function
}

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
export default confirmable(ExtendedConfirmDialog)
